import "../../styles/components/PageLoader.css";

const PageLoader = ({
  title = "Loading",
  message = "Please wait...",
}) => {
  return (
    <main className="page-loader">
      <div className="page-loader-content">
        <div
          className="page-loader-spinner"
          aria-hidden="true"
        />

        <div>
          <h1>{title}</h1>
          <p>{message}</p>
        </div>
      </div>
    </main>
  );
};

export default PageLoader;